module.exports = __webpack_public_path__ + "img/documents_refresh.8bd8b30f.svg";